/**
 * Lookup over the generated legal documents.
 *
 * The text is bundled rather than fetched. These pages have to open for someone who is
 * not signed in and, in the native shell, for someone with no connection — an app store
 * reviewer reaches them from a store listing, and a member reaches them from the code
 * screen before an account even exists. There is no endpoint to gate, nothing to load
 * and nothing to fail.
 */

import { CS_LEGAL_DOCUMENTS } from "./cs";
import { EN_LEGAL_DOCUMENTS } from "./en";
import type { LegalDocument, LegalSlug } from "./types";

export type {
  LegalBlock,
  LegalDocument,
  LegalSection,
  LegalSlug,
} from "./types";
export { isLegalSlug, LEGAL_SLUGS } from "./types";

const BY_LOCALE: Record<string, LegalDocument[]> = {
  cs: CS_LEGAL_DOCUMENTS,
  en: EN_LEGAL_DOCUMENTS,
};

/**
 * The document in the reader's language.
 *
 * Falls back to Czech, which is the catalogue's default and the language the documents
 * were drafted in: an unexpected locale should still show the member a contract, and
 * the Czech text is the one that governs.
 */
export function legalDocument(
  slug: LegalSlug,
  locale: string,
): LegalDocument | undefined {
  const documents = BY_LOCALE[locale] ?? CS_LEGAL_DOCUMENTS;
  return documents.find((document) => document.slug === slug);
}
